/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace with`)
};

const es_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar con`)
};

const de_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzen durch`)
};

const nl_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervangen door`)
};

const fr_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer par`)
};

const it_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisci con`)
};

const pt_br2_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituir por`)
};

const pt_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituir por`)
};

const ja_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`置換する`)
};

const zh_fr_replace_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`替换为`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_replace_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_replace_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_replace_label", locale)
	if (locale === "en") return en_fr_replace_label(inputs)
	if (locale === "es") return es_fr_replace_label(inputs)
	if (locale === "de") return de_fr_replace_label(inputs)
	if (locale === "nl") return nl_fr_replace_label(inputs)
	if (locale === "fr") return fr_fr_replace_label(inputs)
	if (locale === "it") return it_fr_replace_label(inputs)
	if (locale === "pt-BR") return pt_br2_fr_replace_label(inputs)
	if (locale === "pt") return pt_fr_replace_label(inputs)
	if (locale === "ja") return ja_fr_replace_label(inputs)
	return zh_fr_replace_label(inputs)
};